webpackJsonp([5],{

/***/ "/BDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by DELL on 2016/12/12.
 */
var navlist = [
// {
//   src: require('../assets/image/home_navitems/customerservice.png'),
//   icon: 'glyphicon glyphicon-list-alt',
//   iconColor: '#e6c40a',
//   title: '工单系统',
//   menulist: [{ title: '工单配置' }, {title: '工单处理'}],
//   submenulist: [
//     [
//       {type: 'glyphicon glyphicon-cog', id: 'modelConf', text: '服务类型管理', show: '', shortcut: '', go: 'modelConf', color: '#fff', bg: '#2d8dba'},
//       {type: 'glyphicon glyphicon-headphones', id: 'serviceProps', text: '服务属性配置', show: '', shortcut: '', go: 'serviceProps', color: '#fff', bg: '#6f5498'},
//       {type: 'glyphicon glyphicon-magnet', id: 'nodeManage', text: '服务节点管理', show: '', shortcut: '', go: 'nodeManage', color: '#333', bg: '#fbf1c2'},
//       {type: 'glyphicon glyphicon-random', id: 'workflowIndex', text: '服务流程配置', show: '', shortcut: '', go: 'workflowIndex', color: '#fff', bg: '#4dcca4'},
//       {type: 'glyphicon glyphicon-user', id: 'serviceGroup', text: '服务人员配置', show: '', shortcut: '', go: 'serviceGroup', color: '#333', bg: '#ecf0f1'},
//       {type: 'glyphicon glyphicon-send', id: 'serviceProvisioning', text: '服务开通', show: '', shortcut: '', go: 'serviceProvisioning', color: '#fff', bg: '#4eb0de'},
//       {type: 'glyphicon glyphicon-hand-right', id: 'serviceAuth', text: '服务授权', show: '', shortcut: '', go: 'serviceAuth', color: '#fff', bg: '#46bfbd'},
//       {type: 'glyphicon glyphicon-time', id: 'overTime', text: '超时配置', show: '', shortcut: '', go: 'overTime', color: '#fff', bg: '#9e9e9e'}
//     ],
//     [
//       {type: 'glyphicon glyphicon-pencil', id: 'orderInput', text: '工单录入', show: '', shortcut: '', go: 'orderInput', color: '#fff', bg: '#ff6b6b'},
//       {type: 'glyphicon glyphicon-search', id: 'orderQuery', text: '工单查询', show: '', shortcut: '', go: 'orderQuery', color: '#333', bg: '#dff0d8'},
//       {type: 'glyphicon glyphicon-list-alt', id: 'todoOrder', text: '待办/经办工单', show: '', shortcut: '', go: 'todoOrder', color: '#fff', bg: '#337ab7'}
//     ]
//   ]
// }
{
  src: '',
  title: 'WorkStop',
  menulist: [{ title: 'WorkStop' }],
  submenulist: [[{ type: 'glyphicon-eye-open', id: '', text: 'WorkStop', show: '', shortcut: '', go: '' }]]
}, {
  src: '',
  title: 'PD',
  menulist: [{ title: 'PDTree' }],
  submenulist: [[{ type: 'glyphicon-eye-open', id: 'PDIndex', text: 'PD Index', show: '', shortcut: '', go: 'PDIndex' }]]
}, {
  src: '',
  title: 'PI',
  menulist: [{ title: 'ProductInfo' }],
  submenulist: [[{ type: 'glyphicon-eye-open', id: 'ProductInfo', text: 'Product Info', show: '', shortcut: '', go: 'ProductInfo' }, { type: 'glyphicon-eye-open', id: 'Sub-Card', text: 'Sub Card', show: '', shortcut: '', go: 'Sub-Card' }, { type: 'glyphicon-eye-open', id: 'PowerIndicator', text: 'Power Indicator', show: '', shortcut: '', go: 'PowerIndicator' }]]
}, {
  src: '',
  title: 'GIssue',
  menulist: [{ title: 'GeneralIssue' }],
  submenulist: [[{ type: '', id: 'GIssueIndex', text: 'GeneralIssue', show: '', shortcut: '', go: 'GIssueIndex' }]]
}, {
  src: '',
  title: 'RCFRCDecoder',
  menulist: [{ title: 'GeneralIssue' }],
  submenulist: [[{ type: '', id: 'RCFRCDecoderIndex', text: 'RC&FRCDecoder', show: '', shortcut: '', go: 'RCFRCDecoderIndex' }]]
}, {
  src: '',
  title: 'adminPortal',
  menulist: [{ title: 'adminPortal' }],
  submenulist: [[{ type: '', id: 'adminPortal', text: 'Admin Portal', show: '', shortcut: '', go: 'adminPortal' }]]
}, {
  src: '',
  title: 'RCFRCDecoderLog',
  menulist: [{ title: 'RCFRCDecoderLog' }],
  submenulist: [[{ type: '', id: 'RCFRCDecoderLog', text: 'RC&FRCDecoder Log', show: '', shortcut: '', go: 'RCFRCDecoderLog' }]]
  /* {
    src: require('../assets/image/home_navitems/leaderview.png'),
    title: '领导视窗',
    menulist: [{ title: '领导视窗' }],
    submenulist: [
      [{ type: 'glyphicon-eye-open', id: '1.1', text: '领导视窗', show: '', shortcut: '', go: 'leaderview' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/basicmessage.png'),
    title: '基础信息',
    menulist: [{ title: '项目信息' }],
    submenulist: [
      [{ type: 'glyphicon-tasks', id: '2.1', text: '项目管理', show: '', shortcut: '', go: 'projectmanage' }, { type: 'glyphicon-globe', id: '2.2', text: '区域管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-map-marker', id: '2.3', text: '位置管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '2.4', text: '房屋管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-cloud-upload', id: '2.5', text: '上线设置', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/customerrelationship.png'),
    title: '客户关系',
    menulist: [{ title: '客户管理' }],
    submenulist: [
      [{ type: 'glyphicon-search', id: '3.1', text: '综合查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '3.2', text: '用户管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '3.3', text: '业主管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '3.4', text: '租户管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '3.5', text: '访客管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '3.6', text: '来访查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-info-sign', id: '3.7', text: '未注册业主信息', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/customerservice.png'),
    title: '客户服务',
    menulist: [{ title: '呼叫中心' }, { title: '工单管理' }, { title: '作业计划' }, { title: '服务配置' }, { title: '有偿服务' }, { title: '业主服务' }],
    submenulist: [
      [{ type: 'glyphicon-wrench', id: '4.1', text: '坐席配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-log-in', id: '4.2', text: '坐席开通', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '4.3', text: '录音查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '4.4', text: '登录查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon glyphicon-volume-down', id: '4.5', text: '录音统计', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-time', id: '4.6', text: '待办工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-edit', id: '4.7', text: '在办工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-check', id: '4.8', text: '经办工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '4.9', text: '工单查询', show: '', shortcut: '', go: 'orderSearch' }, { type: 'glyphicon-eye-open', id: '4.10', text: '工单督办', show: '', shortcut: '', go: '' }, { type: 'glyphicon-pencil', id: '4.11', text: '工单录入', show: '', shortcut: '', go: '' }, { type: 'glyphicon-ok', id: '4.12', text: '已归档工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '4.13', text: '录音查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '4.14', text: '三级问题归类统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '4.25', text: '工作流配置', show: '', shortcut: '', go: 'workflowSet' }],
      [{ type: 'glyphicon-list-alt', id: '4.15', text: '排班计划', show: '', shortcut: '', go: 'plan' }, { type: 'glyphicon-th', id: '4.16', text: '排班小组', show: '', shortcut: '', go: 'schedualGroup' }],
      [{ type: 'glyphicon-th-list', id: '4.17', text: '问题归类', show: '', shortcut: '', go: '' }, { type: 'glyphicon-log-in', id: '4.18', text: '服务开通', show: '', shortcut: '', go: '' }, { type: 'glyphicon-wrench', id: '4.19', text: '参数配置', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-usd', id: '4.20', text: '有偿定价', show: '', shortcut: '', go: '' }, { type: 'glyphicon-envelope', id: '4.21', text: '服务申请', show: '', shortcut: '', go: '' }, { type: 'glyphicon-cog', id: '4.22', text: '服务审核', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list-alt', id: '4.23', text: '登记申请单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '4.24', text: '装修申请单', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/communitysecurity.png'),
    title: '社区安防',
    menulist: [{ title: '巡更管理' }, { title: '门禁管理' }],
    submenulist: [
      [{ type: 'glyphicon-wrench', id: '5.1', text: '参数设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-map-marker', id: '5.2', text: '巡更点设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-random', id: '5.3', text: '路线设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '5.4', text: '计划设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-facetime-video', id: '5.5', text: '实时监控', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '5.6', text: '统计报表', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-hand-up', id: '5.7', text: '门禁管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-hand-up', id: '5.8', text: '门禁授权', show: '', shortcut: '', go: '' }, { type: 'glyphicon-hand-up', id: '5.9', text: '员工门禁授权', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/communityservice.png'),
    title: '社区服务',
    menulist: [{ title: '资讯管理' }, { title: '广告管理' }, { title: '抽奖管理' }, { title: '社区纷享' }, { title: '快递代收' }, { title: '社区商圈' }, { title: '闲置出借' }, { title: '卡券管理' }, { title: '到家服务' }],
    submenulist: [
      [{ type: 'glyphicon-bullhorn', id: '6.1', text: '社区资讯', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.2', text: '活动管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-bullhorn', id: '6.3', text: '活动发布', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '6.4', text: '便民黄页', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '6.5', text: '房屋租赁', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '6.6', text: '问卷调查-NEW', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '6.7', text: '楼盘信息管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-export', id: '6.8', text: '页眉广告发布', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-gift', id: '6.9', text: '抽奖配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-gift', id: '6.10', text: '兑奖处理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.11', text: '商业活动管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-gift', id: '6.12', text: '商业中奖管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-picture', id: '6.13', text: '生活画报管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-retweet', id: '6.14', text: '帮帮管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.15', text: '专题活动管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-th-large', id: '6.16', text: '社区拼车', show: '', shortcut: '', go: '' }, { type: 'glyphicon-comment', id: '6.17', text: '求助管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-inbox', id: '6.18', text: '快递代收', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-home', id: '6.19', text: '商户管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.20', text: '商品管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-transfer', id: '6.21', text: '闲置交换', show: '', shortcut: '', go: '' }, { type: 'glyphicon-transfer', id: '6.22', text: '闲置交换管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-credit-card', id: '6.23', text: '卡券模板管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-bookmark', id: '6.24', text: '品牌服务管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.25', text: '服务类别管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '6.26', text: '服务商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '6.27', text: '服务项目管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '6.28', text: '服务订单管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-comment', id: '6.30', text: '订单评论管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '6.31', text: '订单退款日志', show: '', shortcut: '', go: '' }, { type: 'glyphicon-comment', id: '6.32', text: '客服回复', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/stopmanage.png'),
    title: '车场管理',
    menulist: [{ title: '车场设置' }, { title: '月卡设置' }, { title: '业务办理' }],
    submenulist: [
      [{ type: 'glyphicon-th', id: '7.1', text: '车场定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-flag', id: '7.2', text: '车位定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '7.3', text: '供应商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-resize-small', id: '7.4', text: '接口维护', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-edit', id: '7.5', text: '类型定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '7.6', text: '费率配置', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-credit-card', id: '7.7', text: '月卡办理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '7.8', text: '月卡充值', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '7.9', text: '充值查询', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/devicemanage.png'),
    title: '设备管理',
    menulist: [{ title: '设备定义' }, { title: '设备信息' }, { title: '设备维保 ' }, { title: '设备监控' }, { title: '能耗管理' }],
    submenulist: [
      [{ type: 'glyphicon-filter', id: '8.1', text: '设备类型管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-sort', id: '8.2', text: '设备分类管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tree-deciduous', id: '8.3', text: '设备树授权', show: '', shortcut: '', go: '' }, { type: 'glyphicon-map-marker', id: '8.4', text: '设备位置管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '8.5', text: '设备供应商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '8.6', text: '设备仓库管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-th-large', id: '8.7', text: '设备分类模板', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list-alt', id: '8.8', text: '设备信息管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-qrcode', id: '8.9', text: '设备二维码管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list', id: '8.10', text: '维保作业计划', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '8.11', text: '设备任务处理', show: '', shortcut: '', go: '' }, {type: 'glyphicon-wrench', id: '8.12', text: '设备异常处理', show: '', shortcut: '', go: ''}],
      [{ type: 'glyphicon-facetime-video', id: '8.13', text: '设备任务监控', show: '', shortcut: '', go: '' }, { type: 'glyphicon-facetime-video', id: '8.14', text: '设备实时监控', show: '', shortcut: '', go: '' }, { type: 'glyphicon-globe', id: '8.15', text: '设备信息地图', show: '', shortcut: '', go: '' }, { type: 'glyphicon-eye-open', id: '8.16', text: '设备运行参数查看', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-dashboard', id: '8.17', text: '仪表读数稽核', show: '', shortcut: '', go: '' }, { type: 'glyphicon-dashboard', id: '8.18', text: '仪表读数对比', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/repositorymanage.png'),
    title: '仓库管理',
    menulist: [{ title: '仓库设置' }, { title: '物料管理' }, { title: '仓库报表' }],
    submenulist: [
      [{ type: 'glyphicon-pushpin', id: '9.1', text: '物品类型定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tree-conifer', id: '9.2', text: '物品类型树定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-pushpin', id: '9.3', text: '物品定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '9.4', text: '仓库定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '9.5', text: '供应商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-filter', id: '9.6', text: '库存阀值定义', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-transfer', id: '9.7', text: '物料调整', show: '', shortcut: '', go: '' }, { type: 'glyphicon-check', id: '9.8', text: '物料盘查', show: '', shortcut: '', go: '' }, {type: 'glyphicon-list-alt', id: '9.9', text: '订单管理', show: '', shortcut: '', go: ''}, {type: 'glyphicon-search', id: '9.10', text: '领用查询', show: '', shortcut: '', go: ''}],
      [{ type: 'glyphicon-saved', id: '9.11', text: '汇总盘点', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '9.12', text: '消耗统计', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/costmanage.png'),
    title: '费用管理',
    menulist: [{ title: '算费配置 ' }, { title: '经营业务管理' }, { title: '算费管理' }, { title: '收费管理' }, { title: '银行托收' }, { title: '财务管理' }, { title: '费用报表' }, { title: '综合查询' }],
    submenulist: [
      [{ type: 'glyphicon-usd', id: '10.1', text: '费用类型配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '10.2', text: '收费标准配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-sort-by-attributes', id: '10.3', text: '分摊规则配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-home', id: '10.4', text: '租赁分摊配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '10.5', text: '租户承租配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-filter', id: '10.6', text: '收费限制配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-leaf', id: '10.7', text: '优惠规则设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '10.8', text: '项目服务设置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-credit-card', id: '10.9', text: '支付方式设置', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-th-list', id: '10.10', text: '经营收费业务定义', show: '', shortcut: '', go: '' }, { type: 'glyphicon-log-in', id: '10.11', text: '经营收费业务开通', show: '', shortcut: '', go: '' }, { type: 'glyphicon-edit', id: '10.12', text: '经营收费业务办理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '10.13', text: '经营收费业务管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list-alt', id: '10.14', text: '计划制定', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '10.15', text: '任务处理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-usd', id: '10.16', text: '前台缴费', show: '', shortcut: '', go: '' }, { type: 'glyphicon-save', id: '10.17', text: '预存管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-asterisk', id: '10.18', text: '欠费管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '10.19', text: '账单管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-resize-horizontal', id: '10.20', text: '费用调整', show: '', shortcut: '', go: '' }, { type: 'glyphicon-print', id: '10.21', text: '收据打印', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '10.22', text: '收费通知单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '10.23', text: '限制帐单查询', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-cog', id: '10.24', text: '银行托收配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-pencil', id: '10.25', text: '托收协议签署', show: '', shortcut: '', go: '' }, { type: 'glyphicon-arrow-right', id: '10.26', text: '托收流程处理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-ok', id: '10.27', text: '轧帐管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-wrench', id: '10.28', text: '过账配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-transfer', id: '10.29', text: '过账处理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list', id: '10.30', text: '实收报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '10.31', text: '应收报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '10.32', text: '欠费报表', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-search', id: '10.33', text: '应收查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '10.34', text: '欠费查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '10.35', text: '实收查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '10.36', text: '员工收款查询', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/rentmanage.png'),
    title: '租赁管理',
    menulist: [{ title: '资源管理' }, { title: '规则设置' }, { title: '业务办理' }, { title: '租控管理' }, { title: '合同管理' }],
    submenulist: [
      [{ type: 'glyphicon-home', id: '11.1', text: '房屋管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-adjust', id: '11.2', text: '房屋拆分合并', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-usd', id: '11.3', text: '收费标准', show: '', shortcut: '', go: '' }, { type: 'glyphicon-cog', id: '11.4', text: '租赁配置', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-tasks', id: '11.5', text: '预定管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-edit', id: '11.6', text: '租赁办理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-upload', id: '11.7', text: '租赁变更', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '11.8', text: '合同缴费', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list-alt', id: '11.9', text: '收入报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '11.10', text: '出租率报表', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-th-large', id: '11.11', text: '合同模板', show: '', shortcut: '', go: '' }, { type: 'glyphicon-search', id: '11.12', text: '合同查询', show: '', shortcut: '', go: '' }, { type: 'glyphicon-bell', id: '11.13', text: '合同提醒规则配置', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/firmmanage.png'),
    title: '企业管理',
    menulist: [{ title: '员工管理' }, { title: '考勤管理' }, { title: '合同管理' }, { title: '有限资源' }, { title: '流程管理' }],
    submenulist: [
      [{ type: 'glyphicon-list-alt', id: '12.1', text: '员工档案', show: '', shortcut: '', go: '' }, { type: 'glyphicon-certificate', id: '12.2', text: '员工技能', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-th', id: '12.3', text: '班次配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '12.4', text: '规则配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-wrench', id: '12.5', text: '设备配置', show: '', shortcut: '', go: '' }, {type: 'glyphicon-list-alt', id: '12.6', text: '考勤计划', show: '', shortcut: '', go: ''}, {type: 'glyphicon-search', id: '12.7', text: '考勤查询', show: '', shortcut: '', go: ''}, { type: 'glyphicon-list-alt', id: '12.8', text: '我的考勤计划', show: '', shortcut: '', go: '' }, {type: 'glyphicon-record', id: '12.9', text: '我的考勤结果', show: '', shortcut: '', go: ''}, {type: 'glyphicon-calendar', id: '12.10', text: '月度考勤', show: '', shortcut: '', go: ''}, {type: 'glyphicon-stats', id: '12.11', text: '全勤率', show: '', shortcut: '', go: ''}],
      [{ type: 'glyphicon-file', id: '12.12', text: '合同管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-cog', id: '12.13', text: '资源属性管理', show: '', shortcut: '', go: '' }, {type: 'glyphicon-filter', id: '12.14', text: '资源类型管理', show: '', shortcut: '', go: ''}, {type: 'glyphicon-th', id: '12.15', text: '资源模板管理', show: '', shortcut: '', go: ''}, { type: 'glyphicon-certificate', id: '12.16', text: '资源模板授权', show: '', shortcut: '', go: '' }, {type: 'glyphicon-list', id: '12.17', text: '资源信息管理', show: '', shortcut: '', go: ''}, {type: 'glyphicon-envelope', id: '12.18', text: '资源申请', show: '', shortcut: '', go: ''}, {type: 'glyphicon-list-alt', id: '12.19', text: '资源使用报表', show: '', shortcut: '', go: ''}],
      [{ type: 'glyphicon-th', id: '12.20', text: '业务模板配置', show: '', shortcut: '', go: '' }, {type: 'glyphicon-user', id: '12.21', text: '用户组管理', show: '', shortcut: '', go: ''}, {type: 'glyphicon-arrow-right', id: '12.22', text: '服务流程配置工作区', show: '', shortcut: '', go: ''}, { type: 'glyphicon-bullhorn', id: '12.23', text: '发布流程管理', show: '', shortcut: '', go: '' }, {type: 'glyphicon-retweet', id: '12.24', text: '业务流程关系', show: '', shortcut: '', go: ''}, {type: 'glyphicon-envelope', id: '12.25', text: '我的申请', show: '', shortcut: '', go: ''}, {type: 'glyphicon-time', id: '12.26', text: '待办任务', show: '', shortcut: '', go: ''}, {type: 'glyphicon-book', id: '12.27', text: '审批历史', show: '', shortcut: '', go: ''}]
    ]
  },
  {
    src: require('../assets/image/home_navitems/staticsform.png'),
    title: '统计报表',
    menulist: [{ title: '费用报表' }, { title: '管理报表' }, { title: '运营报表' }, { title: '设备报表' }],
    submenulist: [
      [{ type: 'glyphicon-list', id: '13.1', text: '实收报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '13.2', text: '应收报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '13.3', text: '账单报表', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-info-sign', id: '13.4', text: '项目信息', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '13.5', text: '员工信息', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '13.6', text: '设备报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '13.7', text: '工单报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '13.8', text: '个人工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-eye-open', id: '13.9', text: '工单跟踪', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '13.10', text: '个人有偿工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '13.11', text: '有偿工单', show: '', shortcut: '', go: '' }, { type: 'glyphicon-eye-open', id: '13.12', text: '全视图', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-stats', id: '13.13', text: '工单统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-comment', id: '13.14', text: '用户反馈', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.15', text: '服务统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.16', text: '活动统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.17', text: '快递统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-usd', id: '13.18', text: '快递结算', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.19', text: '一键开门统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.20', text: '用户注册量', show: '', shortcut: '', go: '' }, { type: 'glyphicon-star', id: '13.21', text: '员工活跃度', show: '', shortcut: '', go: '' }, { type: 'glyphicon-heart', id: '13.22', text: '用户活跃度', show: '', shortcut: '', go: '' }, { type: 'glyphicon-hand-up', id: '13.23', text: '画报点击量', show: '', shortcut: '', go: '' }, { type: 'glyphicon-stats', id: '13.24', text: '一键开门趋势图', show: '', shortcut: '', go: '' }, { type: 'glyphicon-warning-sign', id: '13.25', text: '一键开门错误分析', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-list', id: '13.26', text: '设备个人报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '13.27', text: '设备工单报表', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/firmcommerce.png'),
    title: '企业电商',
    menulist: [{ title: '供应商家管理' }, { title: '商品信息管理' }, { title: '交易流程' }, { title: '销售统计分析' }],
    submenulist: [
      [{ type: 'glyphicon-user', id: '14.1', text: '供应商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '14.2', text: '经销商管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-file', id: '14.3', text: '签约管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-stats', id: '14.4', text: '商品信息管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '14.5', text: '商品管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-th', id: '14.6', text: '商品分类管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-cog', id: '14.7', text: '商品规格管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-plane', id: '14.8', text: '团购快送管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-shopping-cart', id: '14.9', text: '上架管理', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '14.10', text: '订单管理-供应商', show: '', shortcut: '', go: '' }, { type: 'glyphicon-inbox', id: '14.11', text: '订单管理-平台', show: '', shortcut: '', go: '' }, { type: 'glyphicon-tasks', id: '14.12', text: '订单管理', show: '', shortcut: '', go: '' }],
      [{ type: 'glyphicon-stats', id: '14.13', text: '订单汇总统计', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list-alt', id: '14.14', text: '供应商报表', show: '', shortcut: '', go: '' }, { type: 'glyphicon-user', id: '14.15', text: '经销商', show: '', shortcut: '', go: '' }, { type: 'glyphicon-list', id: '14.16', text: '平台商报表', show: '', shortcut: '', go: '' }]
    ]
  },
  {
    src: require('../assets/image/home_navitems/systemmanage.png'),
    title: '系统管理',
    menulist: [{ title: '服务模板' }],
    submenulist: [
      [{ type: 'glyphicon-cloud', id: '15.1', text: '云坐席配置', show: '', shortcut: '', go: '' }, { type: 'glyphicon-align-justify', id: '15.2', text: '词条管理', show: '', shortcut: '', go: '' }]
    ]
  } */
}];

/* harmony default export */ __webpack_exports__["a"] = (navlist);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = cptable;

/***/ }),

/***/ "17x+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5reh");


var _mutations;

/**
 * Created by SJ on 12/6/16.
 */


var globalModule = {
  state: {
    tips: {
      msg: '',
      show: false
    },
    loading: {
      percentage: 0
    },
    destroy: {
      flag: 0,
      name: ''
    },
    region: '',
    lang: '',
    code: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["B" /* SET_TOAST_SHOW */], function (state, msg) {
    state.tips.msg = msg;
    state.tips.show = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["C" /* SET_TOAST_HIDE */], function (state, msg) {
    state.tips.msg = msg;
    state.tips.show = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["D" /* SET_LOADING */], function (state, percentage) {
    state.loading.percentage = percentage;
    if (percentage === 100) {
      setTimeout(function () {
        state.loading.percentage = 0;
      }, 0);
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["E" /* SET_DESTROY */], function (state, name) {
    state.destroy.flag = 1;
    state.destroy.name = name;
    console.log(state.destroy);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["F" /* SET_REGION */], function (state, name) {
    state.region = name;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SET_LANG */], function (state, name) {
    state.lang = name;
  }), _mutations),
  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["A" /* SHOW_TOAST */], function (_ref, msg) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__types__["B" /* SET_TOAST_SHOW */], msg);
    setTimeout(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["C" /* SET_TOAST_HIDE */]);
    }, 3000);
  }),
  getters: {}
};
/* harmony default export */ __webpack_exports__["a"] = (globalModule);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4aor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__("lGom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__("QmSG");



var cookieConfig = { path: '/' };
if (true) {
  cookieConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cookieConfig, { secure: true, sameSite: 'none' });
}
if (__WEBPACK_IMPORTED_MODULE_2__config_js__["CookieDomain"] !== '') {
  cookieConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cookieConfig, { domain: __WEBPACK_IMPORTED_MODULE_2__config_js__["CookieDomain"] });
}
var cookies = new __WEBPACK_IMPORTED_MODULE_1_universal_cookie__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  saveCookie: function saveCookie(name, value) {
    cookies.set(name, value, cookieConfig);
  },
  getCookie: function getCookie(name) {
    return cookies.get(name);
  },
  removeCookie: function removeCookie(name) {
    cookies.remove(name, cookieConfig);
  },
  signOut: function signOut() {
    cookies.remove('wust', cookieConfig);
  },
  isLogin: function isLogin() {
    return !!cookies.get('wust');
  }
});

/***/ }),

/***/ "5reh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_TOAST_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_TOAST_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LOGIN_SUCCESS; });
/* unused harmony export LOGIN */
/* unused harmony export LOGIN_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOG_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLEAR_URERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return READ_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLOSE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SELECT_WORKSTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_TAB_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_TAB_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_TAB_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_TAB_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLEAR_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return JUMP_ROUTE; });
/* unused harmony export HOME_NEWS_DETAIL */
/* unused harmony export HOME_NEWS_DETAIL_SHOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SHOW_SHORTCUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLOSE_SHORTCUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_SHORTCUT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_SHORTCUT_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SHORTCUT; });
/* unused harmony export LOAD_PANELTOP */
/* unused harmony export LOAD_PANELTOP_REFRESH */
/* unused harmony export LOAD_PANELBOTTOM */
/* unused harmony export LOAD_PANELBOTTOM_REFRESH */
/* unused harmony export SET_REFRESH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SWITCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LIST_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHECK_TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TREE_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TREE_DELETE; });
/**
 * Created by SJ on 12/1/16.
 */
var SET_TOAST_SHOW = 'SET_TOAST_SHOW';
var SET_TOAST_HIDE = 'SET_TOAST_HIDE';
var SHOW_TOAST = 'SHOW_TOAST';

var SET_LOADING = 'SET_LOADING';

var SET_DESTROY = 'SET_DESTROY';
var SET_REGION = 'SET_REGION';
var SET_LANG = 'SET_LANG';

var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN = 'LOGIN';
var LOGIN_FAILED = 'LOGIN_FAILED';
var LOG_OUT = 'LOG_OUT';
var CLEAR_URERINFO = 'CLEAR_URERINFO';
var READ_TOKEN = 'READ_TOKEN';

var SHOW_TAB = 'SHOW_TAB';
var CLOSE_TAB = 'CLOSE_TAB';
var SWITCH_TAB = 'SWITCH_TAB';
var SELECT_WORKSTOP = 'SELECT_WORKSTOP';
var SET_TAB_SHOW = 'SET_TAB_SHOW';
var SET_TAB_CLOSE = 'SET_TAB_CLOSE';
var SET_TAB_SELECT = 'SET_TAB_SELECT';
var RESET_TAB_SELECT = 'RESET_TAB_SELECT';
var CLEAR_TABS = 'CLEAR_TABS';
var JUMP_ROUTE = 'JUMP_ROUTE';

var HOME_NEWS_DETAIL = 'HOME_NEWS_DETAIL';
var HOME_NEWS_DETAIL_SHOW = 'HOME_NEWS_DETAIL_SHOW';

var SHOW_SHORTCUT = 'SHOW_SHORTCUT';
var CLOSE_SHORTCUT = 'CLOSE_SHORTCUT';
var SET_SHORTCUT_SHOW = 'SET_SHORTCUT_SHOW';
var SET_SHORTCUT_CLOSE = 'SET_SHORTCUT_CLOSE';
var GET_SHORTCUT = 'GET_SHORTCUT';

var LOAD_PANELTOP = 'LOAD_PANELTOP';
var LOAD_PANELTOP_REFRESH = 'LOAD_PANELTOP_REFRESH';
var LOAD_PANELBOTTOM = 'LOAD_PANELBOTTOM';
var LOAD_PANELBOTTOM_REFRESH = 'LOAD_PANELBOTTOM_REFRESH';
var SET_REFRESH = 'SET_REFRESH';

/* export const HOME_NAV_LIST = 'HOME_NAV_LIST'
export const HOME_NAV_SHOW = 'HOME_NAV_SHOW' */
var SWITCH_LIST = 'SWITCH_LIST';
var LIST_SET = 'LIST_SET';

var CHECK_TREE = 'CHECK_TREE';
var DELETE_TREE = 'DELETE_TREE';
var TREE_CHECK = 'TREE_CHECK';
var TREE_DELETE = 'TREE_DELETE';

/***/ }),

/***/ "8M9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export queryTips */
/* unused harmony export queryKeywords */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("oAV5");
/* eslint-disable */


/* eslint-enable */
function queryTips(condition) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.Tips.queryTips, condition, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryKeywords() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.Tips.queryKeywords, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.global.loading;
  },

  computed: {
    getOpacity: function getOpacity() {
      return this.percentage === 0 || this.percentage === 100 ? 0 : 1;
    },
    getWidth: function getWidth() {
      return this.percentage + '%';
    }
  }
});

/***/ }),

/***/ "ABOT":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.matched.length) ? [_c('router-view')] : [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100vw",
      "height": "100vh"
    },
    attrs: {
      "element-loading-text": "Loading Your Content..."
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__("17x+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_authService__ = __webpack_require__("4aor");


var _mutations, _actions;

/* eslint-disable */





/* eslint-enable */
var authModule = {
  state: {
    userInfo: null,
    wust: null,
    rwCondition: null
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["y" /* LOGIN_SUCCESS */], function (state, payload) {
    console.log(payload);
    state.userInfo = payload.userInfo;
    state.wust = payload.wust;
    state.rwCondition = payload.rwCondition;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["z" /* CLEAR_URERINFO */], function (state) {
    state.token = null;
    state.userInfo = null;
    state.rwCondition = null;
    // window.localStorage.removeItem('Email')
    // window.localStorage.removeItem('LenovoID')
    window.localStorage.clear();
    // window.localStorage.removeItem('ico')
    // window.localStorage.removeItem('name')
    // window.localStorage.removeItem('shortcutId')
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* LOG_OUT */], function (_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_4__utils_authService__["a" /* default */].signOut();
    // window.router.replace('/login')
    // commit(CLEAR_TABS)
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["z" /* CLEAR_URERINFO */]);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* READ_TOKEN */], function (_ref2, para) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["e" /* readToken */])(para.wust).then(function (res) {
      handleData(res);
    }, function (res) {
      dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["A" /* SHOW_TOAST */], 'login failed');
    });
    function handleData(res) {
      console.log(res.data);
      if (res.data.code === '0') {
        console.log('login successfully');
        __WEBPACK_IMPORTED_MODULE_4__utils_authService__["a" /* default */].saveCookie('wust', res.data.data.wust);
        __WEBPACK_IMPORTED_MODULE_4__utils_authService__["a" /* default */].saveCookie('LenovoID.num', res.data.data.LenovoID);
        __WEBPACK_IMPORTED_MODULE_4__utils_authService__["a" /* default */].saveCookie('Email', res.data.data.Email);
        // authService.saveCookie('rwCondition', res.data.data.resRow.rwCondition)
        var payload = {
          wust: res.data.data.wust,
          userInfo: res.data.data,
          rwCondition: res.data.data.resRow.rwCondition
        };
        window.localStorage.setItem('Email', res.data.data.Email);
        window.localStorage.setItem('LenovoID', res.data.data.LenovoID);
        // window.localStorage.setItem('rwCondition', res.data.data.resRow.rwCondition)
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["y" /* LOGIN_SUCCESS */], payload);
        window.location.href = '/';
        // window.router.replace('/home') not this for we need to get rid of those URL parameter
      } else if (res.data.code === '0000003') {
        window.router.replace('/unAuth');
      } else {
        dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["A" /* SHOW_TOAST */], res.data.message);
      }
    }
  }), _actions),
  getters: {}
};
/* harmony default export */ __webpack_exports__["a"] = (authModule);

/***/ }),

/***/ "DzgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5reh");


var _mutations, _actions;

/**
 * Created by DELL on 2017/3/1.
 */

// import tabArr from '../../../utils/tabArr'
var authModule = {
  state: {
    selectId: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["h" /* TREE_CHECK */], function (state, id) {
    // tabArr.addTab(state.treeList, id)
    state.selectId = id;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["i" /* TREE_DELETE */], function (state, id) {
    // tabArr.removeTab(state.treeList, id)
    if (state.selectId === id) state.selectId = '';
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["j" /* CHECK_TREE */], function (_ref, id) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__types__["h" /* TREE_CHECK */], id);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["k" /* DELETE_TREE */], function (_ref2, id) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__types__["i" /* TREE_DELETE */], id);
  }), _actions),
  getters: {}
};
/* harmony default export */ __webpack_exports__["a"] = (authModule);

/***/ }),

/***/ "HaH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by DELL on 2016/12/16.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  indexOfTab: function indexOfTab(arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === val) return i;
    }
    return -1;
  },
  removeTab: function removeTab(arr, val) {
    var index = this.indexOfTab(arr, val);
    if (index > -1) {
      arr.splice(index, 1);
    }
  },
  addTab: function addTab(arr, val) {
    var index = this.indexOfTab(arr, val);
    if (index === -1) {
      arr.push(val);
    }
  },

  // 对象数组中的某一项，当对象的属性field等于val时返回,field是字符串
  getTab: function getTab(arr, val, field, type) {
    if (arr instanceof Array) {
      var len = arr.length;
      for (var i = 0; i < len; i++) {
        if (arr[i][field] === val) {
          return type === 'obj' ? arr[i] : i; // 如果设置type为'obj'，则返回对象，否则返回index
        }
      }
      return -1;
    } else {
      console.log('arr should be array');
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_global__ = __webpack_require__("17x+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_tree__ = __webpack_require__("DzgM");
/**
 * Created by SJ on 12/1/16.
 */







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    global: __WEBPACK_IMPORTED_MODULE_2__modules_global__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_4__modules_home__["a" /* default */],
    tree: __WEBPACK_IMPORTED_MODULE_5__modules_tree__["a" /* default */]
  }
}));

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ddwO")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xJD8"),
  /* template */
  __webpack_require__("ABOT"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_authService__ = __webpack_require__("4aor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// import SchedualGroup from './views/order-system/schedual-group/RenderGroup.vue'
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.crossOrigin = true;
/* eslint-disable no-new */

function requireAuth(to, from, next) {
  console.log('!authService.isLogin()', __WEBPACK_IMPORTED_MODULE_5__utils_authService__["a" /* default */].isLogin());
  console.log('process.env.Auth', __webpack_require__.i({"NODE_ENV":"production"}).Auth);
  if (__webpack_require__.i({"NODE_ENV":"production"}).BACKEND_ENV === 'Electron') {
    next();
  } else if (!__WEBPACK_IMPORTED_MODULE_5__utils_authService__["a" /* default */].isLogin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}
var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/', // __dirname
  routes: [{
    path: '/',
    component: function component(resolve) {
      __webpack_require__.e/* require.ensure */(0).then((function () {
        resolve(__webpack_require__("j7e0"));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    beforeEnter: requireAuth,
    redirect: '/home'
  }, {
    path: '/login',
    component: function component(resolve) {
      __webpack_require__.e/* require.ensure */(3).then((function () {
        resolve(__webpack_require__("lmfZ"));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/unAuth',
    component: function component(resolve) {
      __webpack_require__.e/* require.ensure */(1).then((function () {
        resolve(__webpack_require__("8e0N"));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/apply',
    component: function component(resolve) {
      __webpack_require__.e/* require.ensure */(2).then((function () {
        resolve(__webpack_require__("+6I7"));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  }, { path: '/logout',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_5__utils_authService__["a" /* default */].signOut();
      next('/login');
    }
  }, {
    path: '/home',
    beforeEnter: requireAuth,
    component: function component(resolve) {
      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        resolve(__webpack_require__("j7e0"));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
    // {
    //   path: '/admin',
    //   beforeEnter: requireAuth,
    //   component: function (resolve) {
    //     require.ensure(['./views/admin-view/index.vue'], function () {
    //       resolve(require('./views/admin-view/index.vue'))
    //     })
    //   }
    // }
    // { path: '/hello', component: Hello }
    // { path: '/test', component: resolve => require(['./views/test/Test.vue'], resolve) }
  }]
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], router);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}).$mount('#app');
window.router = router;

/***/ }),

/***/ "NxGh":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("YALK")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8taH"),
  /* template */
  __webpack_require__("ez1x"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-86c12a1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by SJ on 11/30/16.
 */
// export const API_ROOT = (process.env.NODE_ENV === 'production')
//   ? 'https://need to be set/'
//   : 'http://localhost:8888/'
//
// export const CookieDomain = (process.env.NODE_ENV === 'production')
//   ? ''
//   : ''
var configs = {
  hostImg: 'http://localhost:8000/uploads/',
  hostPrime: '' //  开发与生产环境切换

  // if (process.env.NODE_ENV === 'production') {
  //   configs = window.__configs // 在config.js中设置的
  // }
};/* harmony default export */ __webpack_exports__["a"] = (configs);

/***/ }),

/***/ "YALK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZvqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDispatchWhiteList */
/* unused harmony export changeDispatchWhiteList */
/* unused harmony export getClass2CCList */
/* unused harmony export getGuidChain */
/* unused harmony export getFRUList */
/* unused harmony export querySymptomByType */
/* unused harmony export queryTop10Symptom */
/* unused harmony export queryCommonPDSeq */
/* unused harmony export querySolutionSeq */
/* unused harmony export commonPDDump */
/* unused harmony export solutionDump */
/* unused harmony export queryLangProps */
/* unused harmony export FRCValidate */
/* unused harmony export UploadPDTreeServlet */
/* unused harmony export UploadRC2Servlet */
/* unused harmony export NLPPredict */
/* unused harmony export NLPMultiLang */
/* unused harmony export UploadTipsServlet */
/* unused harmony export UploadAISearchServlet */
/* unused harmony export UploadPartsDispatchServlet */
/* unused harmony export UploadStatPDNewServlet */
/* unused harmony export UploadStatP2Servlet */
/* unused harmony export RetrieveRC2Servlet */
/* unused harmony export POIRequest */
/* unused harmony export translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("oAV5");



function getDispatchWhiteList() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.getDispatchWhiteList, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

function changeDispatchWhiteList(PDCODE, pdFruDescription, enabled) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.changeDispatchWhiteList + '?PDCODE=' + PDCODE + '&pd_fru_description=' + pdFruDescription + '&enabled=' + enabled, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

function getClass2CCList() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.getClass2CCList, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

function getGuidChain(MT) {
  return fetch(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.ProductInfo.getGuidChain + '?MT=' + MT, { method: 'get', headers: { 'content-type': 'application/json' } });
}

function getFRUList(MTM, SN, FRUView) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.getFRUList + '?MTM=' + MTM + '&SN=' + SN + '&type=' + FRUView, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

function querySymptomByType(type, region) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.querySymptomByType + '?product=' + type + '&region=' + region, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryTop10Symptom(type, region) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.queryTop10Symptom + '?product=' + type + '&region=' + region, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryCommonPDSeq(COMMONPDCODE) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.queryCommonPDSeq + '?COMMONPDCODE=' + COMMONPDCODE, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function querySolutionSeq(type) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.querySolutionSeq + '?SolutionCode=' + type, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function commonPDDump() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.commonPDDump, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function solutionDump() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.solutionDump, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryLangProps(lang) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.queryLangProps + '?lang=' + lang, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function FRCValidate(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.FRCValidate + '?paramSN=' + param.serialNo + '&paramDS=' + param.date + '&paramFRC=' + param.resCodeP1 + '-' + param.resCodeP2, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function UploadPDTreeServlet(param) {
  // let queryStr = ''
  // for (let i in Object.keys(param)) {
  //   let key = Object.keys(param)[i]
  //   let val = param[key]
  //   queryStr += key + '=' + val
  //   if (i < (Object.keys(param).length - 1)) {
  //     queryStr += '&'
  //   }
  // }
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadPDTreeServlet, param, { emulateJSON: true });
}
function UploadRC2Servlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadRC2Servlet, param, { emulateJSON: true });
}
function NLPPredict(param, type) {
  var url = '';
  if (type === 2) {
    url = __WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.NLPPredict2;
  } else {
    url = __WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.NLPPredict1;
  }
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(url, param, { emulateJSON: false });
}
function NLPMultiLang(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.PDTree.NLPMultiLang, param, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function UploadTipsServlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadTipsServlet, param, { emulateJSON: true });
}
function UploadAISearchServlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadAISearchServlet, param, { emulateJSON: true });
}
function UploadPartsDispatchServlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadPartsDispatchServlet, param, { emulateJSON: true });
}
function UploadStatPDNewServlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadStatPDNewServlet, param, { emulateJSON: true });
}
function UploadStatP2Servlet(param) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.UploadStatP2Servlet, param, { emulateJSON: true });
}

function RetrieveRC2Servlet(SN) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.GAE.RetrieveRC2Servlet + '?diSerial=' + SN, { emulateJSON: true });
}

function POIRequest(para) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.POIRequest, para, { headers: { 'ContentType': 'application/x-www-form-urlencoded' } });
}

function translate(para) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.translate, para, { headers: { 'ContentType': 'application/x-www-form-urlencoded' } });
}

/***/ }),

/***/ "ddwO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ez1x":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segi-loading",
    style: ({
      width: _vm.getWidth,
      opacity: _vm.getOpacity
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export login */
/* harmony export (immutable) */ __webpack_exports__["e"] = readToken;
/* unused harmony export authValidate */
/* unused harmony export createUser */
/* unused harmony export userSearch */
/* unused harmony export userHotUpdate */
/* unused harmony export updateSqlite */
/* harmony export (immutable) */ __webpack_exports__["c"] = getCurrentUserDataById;
/* unused harmony export homePageNewsDetail */
/* harmony export (immutable) */ __webpack_exports__["a"] = queryDatabaseInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = queryLangOpt;
/* unused harmony export queryRegionOpt */
/* harmony export (immutable) */ __webpack_exports__["d"] = getProductSecurityInfo;
/* unused harmony export lowAndHighValueParts */
/* unused harmony export PDCode2Symptom */
/* unused harmony export PDCode2SymptomI1 */
/* unused harmony export MT2SubSeriesI1 */
/* unused harmony export symptomOpt */
/* unused harmony export productSubseriesOpt */
/* unused harmony export fieldsOpt */
/* unused harmony export uploadImg */
/* unused harmony export homePageNavList */
/* unused harmony export homePagePanelTop */
/* unused harmony export homePagePanelTopRefresh */
/* unused harmony export homePagePanelBottom */
/* unused harmony export homePagePanelBottomRefresh */
/* unused harmony export loadOrganTree */
/* unused harmony export querySubTreeById */
/* unused harmony export loadOrganAllTreeByOrganId */
/* unused harmony export queryTreeByKey */
/* unused harmony export queryUserList */
/* unused harmony export loadServiceManagerTree */
/* unused harmony export queryUserByGroupList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_authService__ = __webpack_require__("4aor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_RequestPDTree_js__ = __webpack_require__("ZvqU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_RequestPI_js__ = __webpack_require__("pOs7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_RequestTips_js__ = __webpack_require__("8M9z");
/* unused harmony namespace reexport */
/* eslint-disable */







/* eslint-enable */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// HTTP相关
// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true
// Vue.http.headers = {
//   'Content-Type': 'Content-Type: application/json'
// }
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;

/* 封装请求头,把token 注入到http 头部 */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  // 这里对请求体进行处理
  request.headers = request.headers || {};
  if (__WEBPACK_IMPORTED_MODULE_2__utils_authService__["a" /* default */].getCookie('token')) {
    request.headers.set('token', __WEBPACK_IMPORTED_MODULE_2__utils_authService__["a" /* default */].getCookie('token'));
  }
  next(function (response) {
    // 这里可以对响应的结果进行处理
    console.debug(response);
    if (response.body.code === '0000002' || response.body.code === '0000001') {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__store_types__["f" /* LOG_OUT */]);
      var url = 'https://passport.lenovo.com/glbwebauthnv6/gateway?lenovoid.action=uilogout&lenovoid.realm=seservice.PDGuide.lenovo.com&display=small&bootReg=&lang=en_us&lenovoid.cb=http%3a%2f%2f' + window.location.host + '%2f' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.global.code + '%2flogin'; // window.parent.location.reload() // 针对嵌入iframe cookie失效
      var proxyUrl = 'https://passport.lenovo.com/glbwebauthnv6/gateway?lenovoid.action=uilogout&lenovoid.realm=seservice.PDGuide.lenovo.com&display=small&bootReg=&lang=en_us&lenovoid.cb=https%3a%2f%2fseservice.lenovo.com%2fstatic_file%2fdownload2%2flogin.html' + '%3f' + 'host' + '%3d' + window.location.host +
      //          '%2f' +
      //          this.$store.state.global.code +
      '%2flogin';
      window.location.href =  true ? url : proxyUrl;
    }
    if (!response.ok) {
      // store.dispatch(SHOW_TOAST, 'system error')  // 不用写处理异常的代码
    }
  });
});

/**
 * 登录
 * @param username
 * @param password
 * @returns {*}
 */
function login(username, password) {
  var para = {
    username: username,
    password: password
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.login, para);
}
function readToken(wust) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.readToken, { wust: wust });
}
function authValidate(wust) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.authValidate);
}
function createUser(data) {
  console.log(data);
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.createUser, { users: data }, { emulateJSON: false });
}
function userSearch(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.userSearch, data, { emulateJSON: false });
}
function userHotUpdate(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.userHotUpdate, data, { emulateJSON: false });
}
function updateSqlite() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.PDTree.updateSqlite);
}
function getCurrentUserDataById(id) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.getCurrentUserDataById + '?lenovoID=' + id);
}
/* 首页请求 start */
function homePageNewsDetail(id) {
  var para = {
    pictorialId: id
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePageNewsDetail, para);
}
function queryDatabaseInfo() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.queryDatabaseInfo);
}
function queryLangOpt() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.queryLangOpt);
}
function queryRegionOpt() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.queryRegionOpt);
}
function getProductSecurityInfo() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.getProductSecurityInfo);
}
/* Data Platform */
function lowAndHighValueParts() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.lowAndHighValueParts);
}
function PDCode2Symptom() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.PDCode2Symptom);
}
function PDCode2SymptomI1(pdCode) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.PDCode2SymptomI1 + '?pd_code=' + pdCode);
}
function MT2SubSeriesI1(MT) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.MT2SubSeriesI1 + '?MT=' + MT);
}
function symptomOpt() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.symptomOpt);
}
function productSubseriesOpt() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.productSubseriesOpt);
}
function fieldsOpt(table, field, database, product) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.DP.productSubseriesOpt + '?table=' + table + '&field=' + field + '&database=' + database + '&product=' + product);
}
/* 上传图片 */
function uploadImg(file) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.imgUploadUrl, file);
}

function homePageNavList() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePageNavList);
}

function homePagePanelTop() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePagePanelTop);
}

function homePagePanelTopRefresh() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePagePanelTopRefresh);
}

function homePagePanelBottom() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePagePanelBottom);
}

function homePagePanelBottomRefresh() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.homePagePanelBottomRefresh);
}
/* 首页请求 end */

// , {emulateJSON: false}, {headers: {'ContentType': 'application/json'}}
/* 公共接口 */
/**
 * 根据用户加载组织机构
 * @param userId
 * @return
 */
function loadOrganTree(userId) {
  var par = userId ? { userId: userId } : {};
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.loadOrganTree, par);
}
/**
 * 根据组织机构id查询子属组织机构
 * @param userId
 * @return
 */
function querySubTreeById(id, exclusionOrgTypes) {
  var par = { id: id };
  if (exclusionOrgTypes === 'exclusionOrgTypes') {
    par.exclusionOrgTypes = '2,3,4,5,7,9';
  }
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.querySubTreeById, par);
}
function loadOrganAllTreeByOrganId(organId) {
  var par = { organId: organId };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.loadOrganAllTreeByOrganId, par);
}
/**
 * 根据关键字查询组织机构
 * @param keywords
 * @return
 */
function queryTreeByKey(keywords, exclusionOrgTypes) {
  var par = { keywords: keywords };
  if (exclusionOrgTypes === 'exclusionOrgTypes') {
    par.exclusionOrgTypes = '2,3,4,5,7,9';
  }
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.queryTreeByKey, par);
}

/* 公共接口 查询组织机构员工(不分页) */
function queryUserList(organId, userName) {
  var par = {
    params: {
      organId: organId,
      userName: userName
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.queryUserList, par);
}
/* 公共接口 获取服务处分组信息 */
function loadServiceManagerTree(organId, userName) {
  var par = { organId: organId, userName: userName };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.loadServiceManagerTree, par);
}
/* 公共接口 根据服务处分组获取员工列表 */
function queryUserByGroupList(groupId, userName) {
  var par = {
    params: {
      groupId: groupId,
      userName: userName
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].paths.common.queryUserByGroupList, par);
}
/* 公共接口 */




/***/ }),

/***/ "oAV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export table2Excel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_XLSX__ = __webpack_require__("AlMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_XLSX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_XLSX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blob__ = __webpack_require__("6mly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");





/**
 * Created by SJ on 11/29/16.
 */
// const host = 'http://test.uhomecp.com'
/** 11服务器 **/
// const hostImg = 'http://192.168.1.11:8082'
// const hostPrime = 'http://192.168.1.11:10080'

/** 71服务器 **/
// const hostImg = 'http://120.24.82.71:8082'
// const hostPrime = 'http://120.24.82.71:10080'

/** 打包服务器 **/
// const hostImg = 'http://192.168.1.11:8082'
// const hostPrime = process.env.NODE_ENV === 'development' ? 'http://192.168.1.11:10080' : '' //  开发与生产环境切换
var hostImg = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hostImg;
var hostPrime = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hostPrime;
var Util = {
  paths: {
    readToken: hostPrime + '/user/readToken',
    getCurrentUserDataById: hostPrime + '/getCurrentUserDataById/',
    /*  获取图库文件目录列表  */
    listIcon: hostPrime + '/template-api/rest-api/v5/icon/libs/listIcon.json',
    /*  图库信息获取图片或文件夹列表相关接口 */
    listChildrenIcon: hostPrime + '/template-api/rest-api/v5/icon/libs/listChildrenIcon.json',
    imgUploadUrl: hostPrime + '/uhomecp-app/common/oneFileUpload.json',
    imgServerDoamin: hostImg,
    getProductSecurityInfo: hostPrime + '/getProductSecurityInfo/'
  }

  /**
   * 根据table dom 生成json数据
   * @param table dom
   * @returns {*[]} [0]是array,[1]是标识某些多行或者多列的项
   */
};function generateArray(table) {
  var out = [];
  var rows = table.getElementsByTagName('tr');
  var ranges = [];
  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.getElementsByTagName('td');
    if (!columns.length) columns = row.getElementsByTagName('th');
    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var colspan = cell.colSpan;
      var rowspan = cell.rowSpan;
      var cellValue = cell.innerText;
      if (cellValue !== '' && cellValue === +cellValue) cellValue = +cellValue;

      // Skip ranges
      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) {
            outRow.push(null);
          }
        }
      });

      // Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({
          s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 }
        });
      }

      // Handle Value
      outRow.push(cellValue !== '' ? cellValue : null);

      // Handle Colspan
      if (colspan) for (var k = 0; k < colspan - 1; ++k) {
        outRow.push(null);
      }
    }
    out.push(outRow);
  }
  return [out, ranges];
}

function datenum(v, date1904) {
  if (date1904) {
    v += 1462;
  }
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheetFromArrayOfArrays(data, opts) {
  var ws = {};
  var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
  for (var R = 0; R !== data.length; ++R) {
    for (var C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C]
      };
      if (cell.v == null) continue;
      var cellRef = __WEBPACK_IMPORTED_MODULE_1_XLSX___default.a.utils.encode_cell({ c: C, r: R });

      if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = __WEBPACK_IMPORTED_MODULE_1_XLSX___default.a.SSF._table[14];
        cell.v = datenum(cell.v);
      } else {
        cell.t = 's';
      }

      ws[cellRef] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = __WEBPACK_IMPORTED_MODULE_1_XLSX___default.a.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  if (typeof ArrayBuffer !== 'undefined') {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }return buf;
  } else {
    var buf2 = new Array(s.length);
    for (var j = 0; j !== s.length; ++j) {
      buf2[j] = s.charCodeAt(i) & 0xFF;
    }return buf2;
  }
}

/**
 * 根据table dom 生成 文件
 * @param tableDom
 * @param type
 * @param fn 生成的文件名
 */
function table2Excel(tableDom, type, fn) {
  console.debug(tableDom);
  var oo = generateArray(tableDom);
  var ranges = oo[1];

  /* original data */
  var data = oo[0];
  var wsName = 'SheetJS';

  var wb = new Workbook();
  var ws = sheetFromArrayOfArrays(data);

  /* add ranges to worksheet */
  ws['!merges'] = ranges;

  /* add worksheet to workbook */
  wb.SheetNames.push(wsName);
  wb.Sheets[wsName] = ws;

  console.log(wb);
  var wbout = __WEBPACK_IMPORTED_MODULE_1_XLSX___default.a.write(wb, { bookType: type, bookSST: false, type: 'binary' });
  var fname = (fn || 'test') + '.' + type;
  try {
    __WEBPACK_IMPORTED_MODULE_0_file_saver___default.a.saveAs(new __WEBPACK_IMPORTED_MODULE_2_blob___default.a([s2ab(wbout)], { type: 'application/octet-stream' }), fname);
  } catch (e) {
    console.log(e, wbout);
  }
  return wbout;
}

/* harmony default export */ __webpack_exports__["a"] = (Util);

/***/ }),

/***/ "pOs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export queryModelAnaByType */
/* unused harmony export queryModelAnaByTypeAndParts */
/* unused harmony export queryModel */
/* unused harmony export queryProductLineByMTBrandKoala */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("oAV5");
/* eslint-disable */


/* eslint-enable */
function queryModelAnaByType(type) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.ProductInfo.queryModelAnaByType + '?product=' + type, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryModelAnaByTypeAndParts(type, part) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.ProductInfo.queryModelAnaByTypeAndParts + '?product=' + type + '&part=' + part, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}
function queryModel(val) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.ProductInfo.queryModel + '?model=' + val, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

function queryProductLineByMTBrandKoala(MT, Brand, TrackingNumber) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].paths.ProductInfo.queryProductLineByMTBrandKoala + '?MT=' + MT + '&Brand=' + Brand + '&TrackingNumber=' + TrackingNumber, { emulateJSON: false }, { headers: { 'ContentType': 'application/json' } });
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_authService__ = __webpack_require__("4aor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading___default.a
  },
  data: function data() {
    return {
      loggedIn: __WEBPACK_IMPORTED_MODULE_0__utils_authService__["a" /* default */].isLogin(),
      spinnerMarginTop: 0,
      loading: true
    };
  }
});

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tabArr__ = __webpack_require__("HaH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_navlist__ = __webpack_require__("/BDj");



var _mutations, _actions;

/**
 * Created by DELL on 2016/12/16.
 */



// import {homePageNewsDetail, homePageNavList, homePagePanelTop, homePagePanelTopRefresh, homePagePanelBottom, homePagePanelBottomRefresh} from '../../api'

/* homePageNavList().then((response) => {
  homeModule.state.navList = response.body
  for (let i = 0; i < response.body.length; i++) {
    homeModule.state.navList[i].src = require('../../assets/image/home_navitems/' + response.body[i].src)
  }
}, (response) => {
  console.log(response)
})
homePagePanelTop().then((response) => {
  homeModule.state.panelTop = response.body
}, (response) => {
  console.log(response)
})
homePagePanelBottom().then((response) => {
  homeModule.state.panelBottom = response.body
}, (response) => {
  console.log(response)
}) */

var homeModule = {
  state: {
    navList: __WEBPACK_IMPORTED_MODULE_4__data_navlist__["a" /* default */],
    shortcutId: window.localStorage.getItem('shortcutId') ? window.localStorage.getItem('shortcutId') : '',
    /* panelTop: [],
    panelBottom: [], */
    /* rotateTop: false,
     rotateBottom: false, */
    selection: window.sessionStorage.getItem('selection') ? window.sessionStorage.getItem('selection') : 'workstop', // 被选中的tab
    tabs: window.sessionStorage.getItem('tabs') ? window.sessionStorage.getItem('tabs').split(',') : [], // 打开的tabs
    shortcuts: [], // 添加的快捷链接
    newsDetail: '<img src="http://cdn.uehtml.com/201402/1392662591224_1140x0.gif" width="400" height="300">' //
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["l" /* JUMP_ROUTE */], function (state, item) {
    var go = '/home/' + item.go;
    window.router.push({ path: go, query: { refresh: item.refresh } });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["m" /* SET_TAB_SHOW */], function (state, item) {
    item.show = true;
    __WEBPACK_IMPORTED_MODULE_3__utils_tabArr__["a" /* default */].addTab(state.tabs, item.id); // tabs数组增加tab
    window.sessionStorage.setItem('tabs', state.tabs.join(',')); // 更新localStorage
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["n" /* SET_TAB_CLOSE */], function (state, item) {
    item.show = false;
    __WEBPACK_IMPORTED_MODULE_3__utils_tabArr__["a" /* default */].removeTab(state.tabs, item.id); // tabs数组删除tab
    window.sessionStorage.setItem('tabs', state.tabs.join(',')); // 更新localStorage
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["o" /* SET_TAB_SELECT */], function (state, item) {
    state.selection = item.id;
    window.sessionStorage.setItem('selection', item.id);
    // window.router.push(go)
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* RESET_TAB_SELECT */], function (state) {
    state.selection = 'workstop';
    window.sessionStorage.setItem('selection', 'workstop');
    window.router.push('/home');
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["p" /* CLEAR_TABS */], function (state) {
    state.tabs = [];
    state.shortcuts = [];
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["q" /* LIST_SET */], function (state, item) {
    state.list = item.link;
    state.navTitle = item.title;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["r" /* SET_SHORTCUT_SHOW */], function (state, item) {
    item.shortcut = true;
    __WEBPACK_IMPORTED_MODULE_3__utils_tabArr__["a" /* default */].addTab(state.shortcuts, item.id); // shortcuts数组增加快捷链接
    if (state.shortcutId) window.localStorage.setItem(state.shortcutId, state.shortcuts.join(',')); // 更新localStorage
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["s" /* SET_SHORTCUT_CLOSE */], function (state, item) {
    item.shortcut = false;
    __WEBPACK_IMPORTED_MODULE_3__utils_tabArr__["a" /* default */].removeTab(state.shortcuts, item.id); // shortcuts数组删除快捷链接
    if (state.shortcutId) window.localStorage.setItem(state.shortcutId, state.shortcuts.join(',')); // 更新localStorage
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* GET_SHORTCUT */], function (state, userInfo) {
    // state.shortcuts = window.localStorage.getItem(state.userId) ? window.localStorage.getItem(state.userId).split(',') : []
    var shortcutId = userInfo ? userInfo.userId + 'shortcut' : state.shortcutId;
    if (shortcutId) {
      state.shortcutId = shortcutId;
      state.shortcuts = window.localStorage.getItem(shortcutId) ? window.localStorage.getItem(shortcutId).split(',') : [];
    } else {
      state.shortcutId = '';
      state.shortcuts = [];
    }
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* SHOW_TAB */], function (_ref, item) {
    var commit = _ref.commit;

    /* 如果所打开的tab没有关闭 则直接从内存加载 */
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["m" /* SET_TAB_SHOW */], item);
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["o" /* SET_TAB_SELECT */], item);
    // if (state.tabs.indexOf(item.id) > -1) {
    //   commit(JUMP_ROUTE, {...item, refresh: false})
    // } else {
    //   commit(JUMP_ROUTE, {...item, refresh: true})
    // }
    if (!item.notRouteUpdate) {
      commit(__WEBPACK_IMPORTED_MODULE_2__types__["l" /* JUMP_ROUTE */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { refresh: true }));
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["t" /* CLOSE_TAB */], function (_ref2, item) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["n" /* SET_TAB_CLOSE */], item);
    if (state.selection === item.id) {
      commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* RESET_TAB_SELECT */]);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* SWITCH_TAB */], function (_ref3, item) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["o" /* SET_TAB_SELECT */], item);
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["l" /* JUMP_ROUTE */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { refresh: false }));
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["u" /* SELECT_WORKSTOP */], function (_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* RESET_TAB_SELECT */]);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["v" /* SWITCH_LIST */], function (_ref5, item) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["q" /* LIST_SET */], item);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["w" /* SHOW_SHORTCUT */], function (_ref6, item) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["r" /* SET_SHORTCUT_SHOW */], item);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types__["x" /* CLOSE_SHORTCUT */], function (_ref7, item) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__types__["s" /* SET_SHORTCUT_CLOSE */], item);
  }), _actions),
  getters: {}
};
/* harmony default export */ __webpack_exports__["a"] = (homeModule);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e12ba6dbb2f77e876df0.js